import React, { useEffect, useRef, useState } from "react";

const ScreenSteps = (props) => {
  const [currentStep, setStep] = useState(0);
  const [loading, setLoading] = useState(false);
  const [visibility, setVisibility] = useState(true);
  let divRef = useRef({});

  const move = async (action) => {
    let totalSteps = props.children.length;
    // 0 , 1 , 2
    try {
      // childRef.current.getAlert()
      let permission = await divRef.current[currentStep].proceed();
      if (permission) {
        if (action === "forward") {
          //#########
          //This condition is hardcoded for a customised need.. Should be removed for normal and uncustomised functioning
          if (currentStep < totalSteps - 1) {
            setStep(currentStep + 1);
          }
          //#######
        } else if (action == "backward") {
          if (currentStep > 0) {
            setStep(currentStep - 1);
          }
        }
      }
    } catch (error) {
      alert(error);
    }
  };

  const moveDirectly = (action) => {
    let totalSteps = props.children.length;
    if (action === "forward") {
      if (currentStep < totalSteps - 1) {
        setStep(currentStep + 1);
      }
    } else if (action == "backward") {
      if (currentStep > 0) {
        setStep(currentStep - 1);
      }
    }
  };

  return (
    <div className="h-100">
      {/* cloneElement(children, { ...newProps, ref: node => { doSomething(node); if (children.ref) children.ref(node) } }) */}

      {props.children.map((children, index) => {
        return currentStep == index
          ? React.cloneElement(children, {
              step: index,
              setLoading: (value) => setLoading(value),
              setVisibility: setVisibility,
              setStep: setStep,
              moveDirectly: moveDirectly,
              ref: (node) => {
                divRef.current[index] = node;
              },
            })
          : null;
      })}

      <div
        className="text-center mt-2 "
        style={{ position: "relative", bottom: 0 }}
      >
        {currentStep > 0 && (
          <button
            className="btn btn-secondary mr-3"
            onClick={() => move("backward")}
            disabled={loading}
            style={{ visibility: visibility ? "visible" : "hidden" }}
          >
            Previous
          </button>
        )}
        <button
          className="btn btn-primary btn-custom ml-2"
          onClick={() => move("forward")}
          disabled={loading}
          style={{ visibility: visibility ? "visible" : "hidden" }}
        >
          Proceed
        </button>
      </div>
    </div>
  );
};

export default ScreenSteps;
